
























import {Component, Vue} from 'vue-property-decorator'
import Modal from '@/components/common/Modal.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {Room, RoomType, Lead, Location} from '@/store/types'
import FontAwesome from '@/classes/FontAwesome'

@Component({
  components: {
    Modal,
  },
})
export default class InventoryRoomOverlay extends Vue {
  @Getter('lead') public lead!: Lead
  @Getter('location') public location!: Location
  @Getter('roomTypes') public roomTypes!: RoomType[]
  @Getter('roomTypesWithoutCustom') public roomTypesWithoutCustom!: RoomType[]
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Mutation('setInventoryRoomOverlay') public setInventoryRoomOverlay!: any
  @Mutation('setInventoryCustomRoomOverlay') public setInventoryCustomRoomOverlay!: any
  @Mutation('setInventoryItemListOverlay') public setInventoryItemListOverlay!: any
  @Action('addRoom') public addRoom!: any

  public FontAwesome = FontAwesome

  public add(room: RoomType) {
    const data = {
      lead_id: this.lead.id,
      lead_location_id: this.location.id,
      room_id: room.id,
      name: '',
    }
    this.addRoom(data).then((room: Room) => {
      this.setActiveRoomId(room.id)
      this.setInventoryRoomOverlay(false)
      this.setInventoryItemListOverlay(true)
    })
  }
  public createCustomRoom() {
    this.setInventoryRoomOverlay(false)
    this.setInventoryCustomRoomOverlay(true)
  }
}
